import { render, staticRenderFns } from "./SelectPolice.vue?vue&type=template&id=2c7d1719&scoped=true&"
import script from "./SelectPolice.vue?vue&type=script&lang=js&"
export * from "./SelectPolice.vue?vue&type=script&lang=js&"
import style0 from "./SelectPolice.vue?vue&type=style&index=0&id=2c7d1719&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d1719",
  null
  
)

export default component.exports